import './Final.css';
import ScrollableBlock from "../ScrollableBlock/ScrollableBlock";
import final from '../../../assets/images/final.webp'

function Final() {

    return (
        <ScrollableBlock>
            <p className='about-page__text'>
                Over the years, we&nbsp;have built a&nbsp;reputation for our commitment to&nbsp;authenticity, quality, and customer satisfaction. We&nbsp;ensure that every timepiece you purchase from Sany is&nbsp;a&nbsp;true investment.
                As&nbsp;a&nbsp;company rooted in&nbsp;the values of&nbsp;integrity and excellence, we&nbsp;are dedicated to&nbsp;providing a&nbsp;seamless and personalized shopping experience. Our knowledgeable team is&nbsp;always here to&nbsp;guide you through your purchase, offering expert advice and insights into the world of&nbsp;luxury watches.  </p><br></br>
            <p className='about-page__text'>
                Sany is&nbsp;more than just a&nbsp;marketplace&mdash;it&rsquo;s a&nbsp;community of&nbsp;watch enthusiasts who share a&nbsp;passion
                for horology. We&nbsp;invite you to&nbsp;explore our curated collection and discover the perfect timepiece
                that speaks to&nbsp;you.
            </p>
            <img src={final} className='about-page__final__img' alt='' />
        </ScrollableBlock>
    );
}

export default Final